import React from "react";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import Modal from "../modal";
import UnitInput from "../inputs/unit-input";
import { useRillContext } from "../../rill/RillReact/share/base";
const id = "modal-update-rep-maximum";

function UpdateRepMaximumModal(props) {
  const { t } = useTranslation("coaching-portal");
  const { locals } = useRillContext();

  const { query, editExercise, activeUser } = locals;
  const primary = _.get(query, "primary", "squat");
  const defaultRepMax = _.get(
    editExercise,
    `repMaximums.${primary}`,
    _.get(activeUser, `repMaximums.${primary}`, 0)
  );
  return (
    <form
      action={`/actions/exercise/rep-max/${_.get(editExercise, "_id", "")}`}
      method="POST"
      data-noreset
    >
      <Modal name={id} key={id} width="600px">
        <div className="head">
          <h2 className="alt">
            {t("updateRepMaximum.title", {
              primary: _.capitalize(primary),
            })}
          </h2>
        </div>

        <div className="body">
          <div className="columns">
            <div className="column" data-col="1/2">
              <input type="hidden" name="primary" value={primary} />
              <UnitInput
                metric="kg"
                imperial="lb"
                className="text-input"
                name="repMax"
                placeholder={t("updateRepMaximum.weightPlaceholder")}
                min="1"
                defaultValue={_.round(defaultRepMax, 2)}
              />
            </div>

            <div className="column" data-col="1/1">
              <label className="checkbox-input">
                <input type="checkbox" name="overwrite" />
                <span className="checkbox"></span>
                <span className="text">
                  {t("updateRepMaximum.overwriteLabel", { primary })}
                </span>
              </label>
            </div>
          </div>
        </div>

        <div className="foot">
          <div className="columns">
            <div className="column" data-col="1/2">
              <button className="button-input" type="submit">
                {t("updateRepMaximum.update")}
              </button>
            </div>

            <div className="column mobile-hidden" data-col="1/2">
              <a className="cancel" href="/actions/refresh?modal=">
                {t("common:cancel")}
              </a>
            </div>
          </div>
        </div>
      </Modal>
    </form>
  );
}

export { id };
export { UpdateRepMaximumModal as default };
